import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'

import { CMSState } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { Dropdown, Label } from 'office-ui-fabric-react'
import { gtmPush } from '../../../../../helpers'
import i18next from 'i18next'

type Region = 'international' | 'asia' | 'china' | 'indonesia' | 'belgium-nl' | 'belgium-fr' | 'netherlands' | 'nigeria' | 'pakistan' | 'mexico' | 'other' 

export type NewsletterBlockProps = {
  block_index: number
  newsletter: Region
  initialNewsletter: Region
}

export type NewsletterBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
}>

export function NewsletterBlock<CustomBlockData, extra_images>(
  props: NewsletterBlockProps,
  options?: { key?: string }
): (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {

  const setBlockState = <K extends keyof NewsletterBlockProps>(prop: K, newValue: NewsletterBlockProps[K]) => (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>): CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData> => {
    if (!s.blocks.has(props.block_index)) return s
    let current_block = s.blocks.get(props.block_index) as any
    if (current_block.kind != 'newsletterBlock') return s
    current_block = ({
      ...current_block,
      value: {
        ...current_block.value,
        fst: {
          ...current_block.value.fst,
          [prop]: newValue
        },

      }
    })
    return ({ ...s, blocks: s.blocks.set(props.block_index, current_block) })
  }

  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: setState => (
        <section
          className="block block--form"
          key={options && options.key ? options.key : 'iframe-block'}
        >
          <div className="block__inner container container--s gutter--m spacing--m">
            <div className="block__content">
              {props.initialNewsletter == 'international' && <>
                <Label className={`h3 form__label`}>
                  {i18next.t('newsletter.message')}
                </Label>
                <Dropdown
                  placeholder={i18next.t('newsletter.placeholder')}
                  options={[
                    {
                      "id": "other",
                      "key": "other",
                      "text": i18next.t('newsletter.countries.other')
                    },
                    {
                      "id": "asia",
                      "key": "asia",
                      "text": i18next.t('newsletter.countries.asia')
                    },
                    {
                      "id": "mexico",
                      "key": "mexico",
                      "text": i18next.t('newsletter.countries.mexico')
                    },

                  ]}
                  onChange={(_, selected_answer: any) => {
                    setState(setBlockState('newsletter', selected_answer.id))
                  }}
                  errorMessage={""}
                  styles={{ dropdown: { width: 300 }, root: { height: 100 } }}
                />
              </>}

              {props.newsletter == 'asia' ?
                <NewsletterAsia /> :
                props.newsletter == 'china' ?
                  <NewsletterChina /> :
                  props.newsletter == 'indonesia' ?
                    <NewsletterIndonesia /> :
                    props.newsletter == 'belgium-nl' ?
                      <NewsletterBelgiumNl /> :
                      props.newsletter == 'belgium-fr' ?
                        <NewsletterBelgiumFr /> :
                        props.newsletter == 'netherlands' ?
                          <NewsletterNetherlands /> :
                          props.newsletter == 'nigeria' ?
                            <NewsletterNigeria /> :
                              props.newsletter == 'pakistan' ?
                              <NewsletterPakistan /> :
                                props.newsletter == 'mexico' ?
                                <NewsletterMexico /> :
                                  props.newsletter == 'other' ?
                                    <NewsletterInternational /> :
                                    null
              }
            </div>
          </div>
        </section>
      )
    })
}

const NewsletterInternational = () =>


  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} 
   action="//hoppinger.createsend.com/t/r/s/dhiumj/" method="post" data-newsletter>

    <input className="form__input typo--m" type="hidden" name="cm-f-ttillrdr" value="b4ccaca8bea6da1a1d1e0b36965a6898" />

    <div className="form__group">
      <label className="form__label" htmlFor="fieldciykiik">Salutation <b className="required">*</b></label>
      <select id="fieldciykiik" name="cm-fo-ciykiik" required>
        <option value="">Choose a salutation...</option>
        <option value="7048868">Emeritus Professor</option>
        <option value="7048869">Professor</option>
        <option value="7048870">A&#x2F;Professor</option>
        <option value="7048871">Dr.</option>
        <option value="6905825">Mr.</option>
        <option value="6905826">Mrs.</option>
        <option value="7048872">Miss</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldName">First name <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldName" name="cm-name" type="text" placeholder="Your name" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldciykidl">Last name <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldciykidl" name="cm-f-ciykidl" placeholder="Your last name" required type="text" />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">Email <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-dhiumj-dhiumj" placeholder="Your email address" type="email" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldciykidk">Country <b className="required">*</b></label>
      <select id="fieldciykidk" name="cm-fo-ciykidk" required>
        <option value="">Please choose your country...</option>
        <option value="6905827">Afghanistan</option>
        <option value="6905828">Albania</option>
        <option value="6905829">Algeria</option>
        <option value="6905830">American Samoa</option>
        <option value="6905831">Andorra</option>
        <option value="6905832">Angola</option>
        <option value="6905833">Anguilla</option>
        <option value="6905834">Antigua &amp; Barbuda</option>
        <option value="6905835">Argentina</option>
        <option value="6905836">Armenia</option>
        <option value="6905837">Aruba</option>
        <option value="6905838">Australia</option>
        <option value="6905839">Austria</option>
        <option value="6905840">Azerbaijan</option>
        <option value="6905841">Azores</option>
        <option value="6905842">Bahamas</option>
        <option value="6905843">Bahrain</option>
        <option value="6905844">Bangladesh</option>
        <option value="6905845">Barbados</option>
        <option value="6905846">Belarus</option>
        <option value="6905847">Belgium</option>
        <option value="6905848">Belize</option>
        <option value="6905849">Benin</option>
        <option value="6905850">Bermuda</option>
        <option value="6905851">Bhutan</option>
        <option value="6905852">Bolivia</option>
        <option value="6905853">Bonaire</option>
        <option value="6905854">Bosnia &amp; Herzegovina</option>
        <option value="6905855">Botswana</option>
        <option value="6905856">Brazil</option>
        <option value="6905857">British Indian Ocean Ter</option>
        <option value="6905858">Brunei</option>
        <option value="6905859">Bulgaria</option>
        <option value="6905860">Burkina Faso</option>
        <option value="6905861">Burundi</option>
        <option value="6905862">Cambodia</option>
        <option value="6905863">Cameroon</option>
        <option value="6905864">Canada</option>
        <option value="6905865">Canary Islands</option>
        <option value="6905866">Cape Verde</option>
        <option value="6905867">Cayman Islands</option>
        <option value="6905868">Central African Republic</option>
        <option value="6905869">Chad</option>
        <option value="6905870">Channel Islands</option>
        <option value="6905871">Chile</option>
        <option value="6905872">China</option>
        <option value="6905873">Christmas Island</option>
        <option value="6905874">Cocos Island</option>
        <option value="6905875">Colombia</option>
        <option value="6905876">Comoros</option>
        <option value="6905877">Congo</option>
        <option value="6905878">Congo Democratic Rep</option>
        <option value="6905879">Cook Islands</option>
        <option value="6905880">Costa Rica</option>
        <option value="6905881">Cote D&#x27;Ivoire</option>
        <option value="6905882">Croatia</option>
        <option value="6905883">Cuba</option>
        <option value="6905884">Curacao</option>
        <option value="6905885">Cyprus</option>
        <option value="6905886">Czech Republic</option>
        <option value="6905887">Denmark</option>
        <option value="6905888">Djibouti</option>
        <option value="6905889">Dominica</option>
        <option value="6905890">Dominican Republic</option>
        <option value="6905891">East Timor</option>
        <option value="6905892">Ecuador</option>
        <option value="6905893">Egypt</option>
        <option value="6905894">El Salvador</option>
        <option value="6905895">Equatorial Guinea</option>
        <option value="6905896">Eritrea</option>
        <option value="6905897">Estonia</option>
        <option value="6905898">Ethiopia</option>
        <option value="6905899">Falkland Islands</option>
        <option value="6905900">Faroe Islands</option>
        <option value="6905901">Fiji</option>
        <option value="6905902">Finland</option>
        <option value="6905903">France</option>
        <option value="6905904">French Guiana</option>
        <option value="6905905">French Polynesia</option>
        <option value="6905906">French Southern Ter</option>
        <option value="6905907">Gabon</option>
        <option value="6905908">Gambia</option>
        <option value="6905909">Georgia</option>
        <option value="6905910">Germany</option>
        <option value="6905911">Ghana</option>
        <option value="6905912">Gibraltar</option>
        <option value="6905913">Great Britain</option>
        <option value="6905914">Greece</option>
        <option value="6905915">Greenland</option>
        <option value="6905916">Grenada</option>
        <option value="6905917">Guadeloupe</option>
        <option value="6905918">Guam</option>
        <option value="6905919">Guatemala</option>
        <option value="6905920">Guernsey</option>
        <option value="6905921">Guinea</option>
        <option value="6905922">Guinea-Bissau</option>
        <option value="6905923">Guyana</option>
        <option value="6905924">Haiti</option>
        <option value="6905925">Honduras</option>
        <option value="6905926">Hong Kong</option>
        <option value="6905927">Hungary</option>
        <option value="6905928">Iceland</option>
        <option value="6905929">India</option>
        <option value="6905930">Indonesia</option>
        <option value="6905931">Iran</option>
        <option value="6905932">Iraq</option>
        <option value="6905933">Ireland</option>
        <option value="6905934">Isle of Man</option>
        <option value="6905935">Israel</option>
        <option value="6905936">Italy</option>
        <option value="6905937">Jamaica</option>
        <option value="6905938">Japan</option>
        <option value="6905939">Jersey</option>
        <option value="6905940">Jordan</option>
        <option value="6905941">Kazakhstan</option>
        <option value="6905942">Kenya</option>
        <option value="6905943">Kiribati</option>
        <option value="6905944">Korea North</option>
        <option value="6905945">Korea South</option>
        <option value="6905946">Kuwait</option>
        <option value="6905947">Kyrgyzstan</option>
        <option value="6905948">Laos</option>
        <option value="6905949">Latvia</option>
        <option value="6905950">Lebanon</option>
        <option value="6905951">Lesotho</option>
        <option value="6905952">Liberia</option>
        <option value="6905953">Libya</option>
        <option value="6905954">Liechtenstein</option>
        <option value="6905955">Lithuania</option>
        <option value="6905956">Luxembourg</option>
        <option value="6905957">Macau</option>
        <option value="6905958">Macedonia</option>
        <option value="6905959">Madagascar</option>
        <option value="6905960">Malawi</option>
        <option value="6905961">Malaysia</option>
        <option value="6905962">Maldives</option>
        <option value="6905963">Mali</option>
        <option value="6905964">Malta</option>
        <option value="6905965">Marshall Islands</option>
        <option value="6905966">Martinique</option>
        <option value="6905967">Mauritania</option>
        <option value="6905968">Mauritius</option>
        <option value="6905969">Mayotte</option>
        <option value="6905970">Mexico</option>
        <option value="6905971">Midway Islands</option>
        <option value="6905972">Moldova</option>
        <option value="6905973">Monaco</option>
        <option value="6905974">Mongolia</option>
        <option value="6905975">Montenegro</option>
        <option value="6905976">Montserrat</option>
        <option value="6905977">Morocco</option>
        <option value="6905978">Mozambique</option>
        <option value="6905979">Myanmar</option>
        <option value="6905980">Namibia</option>
        <option value="6905981">Nauru</option>
        <option value="6905982">Nepal</option>
        <option value="6905983">Netherland Antilles</option>
        <option value="6905984">Netherlands</option>
        <option value="6905985">Nevis</option>
        <option value="6905986">New Caledonia</option>
        <option value="6905987">New Zealand</option>
        <option value="6905988">Nicaragua</option>
        <option value="6905989">Niger</option>
        <option value="6905990">Nigeria</option>
        <option value="6905991">Niue</option>
        <option value="6905992">Norfolk Island</option>
        <option value="6905993">Norway</option>
        <option value="6905994">Oman</option>
        <option value="6905995">Pakistan</option>
        <option value="6905996">Palau Island</option>
        <option value="6905997">Palestine</option>
        <option value="6905998">Panama</option>
        <option value="6905999">Papua New Guinea</option>
        <option value="6906000">Paraguay</option>
        <option value="6906001">Peru</option>
        <option value="6906002">Philippines</option>
        <option value="6906003">Pitcairn Island</option>
        <option value="6906004">Poland</option>
        <option value="6906005">Portugal</option>
        <option value="6906006">Puerto Rico</option>
        <option value="6906007">Qatar</option>
        <option value="6906008">Reunion</option>
        <option value="6906009">Romania</option>
        <option value="6906010">Russia</option>
        <option value="6906011">Rwanda</option>
        <option value="6906012">Saipan</option>
        <option value="6906013">Samoa</option>
        <option value="6906014">Samoa American</option>
        <option value="6906015">San Marino</option>
        <option value="6906016">Sao Tome &amp; Principe</option>
        <option value="6906017">Saudi Arabia</option>
        <option value="6906018">Senegal</option>
        <option value="6906019">Serbia</option>
        <option value="6906020">Serbia &amp; Montenegro</option>
        <option value="6906021">Seychelles</option>
        <option value="6906022">Sierra Leone</option>
        <option value="6906023">Singapore</option>
        <option value="6906024">Slovakia</option>
        <option value="6906025">Slovenia</option>
        <option value="6906026">Solomon Islands</option>
        <option value="6906027">Somalia</option>
        <option value="6906028">South Africa</option>
        <option value="6906029">South Sudan</option>
        <option value="6906030">Spain</option>
        <option value="6906031">Sri Lanka</option>
        <option value="6906032">St Barthelemy</option>
        <option value="6906033">St Eustatius</option>
        <option value="6906034">St Helena</option>
        <option value="6906035">St Kitts-Nevis</option>
        <option value="6906036">St Lucia</option>
        <option value="6906037">St Maarten</option>
        <option value="6906038">St Pierre &amp; Miquelon</option>
        <option value="6906039">St Vincent &amp; Grenadines</option>
        <option value="6906040">Sudan</option>
        <option value="6906041">Suriname</option>
        <option value="6906042">Swaziland</option>
        <option value="6906043">Sweden</option>
        <option value="6906044">Switzerland</option>
        <option value="6906045">Syria</option>
        <option value="6906046">Tahiti</option>
        <option value="6906047">Taiwan</option>
        <option value="6906048">Tajikistan</option>
        <option value="6906049">Tanzania</option>
        <option value="6906050">Thailand</option>
        <option value="6906051">Togo</option>
        <option value="6906052">Tokelau</option>
        <option value="6906053">Tonga</option>
        <option value="6906054">Trinidad &amp; Tobago</option>
        <option value="6906055">Tunisia</option>
        <option value="6906056">Turkey</option>
        <option value="6906057">Turkmenistan</option>
        <option value="6906058">Turks &amp; Caicos Is</option>
        <option value="6906059">Tuvalu</option>
        <option value="6906060">Uganda</option>
        <option value="6906061">Ukraine</option>
        <option value="6906062">United Arab Emirates</option>
        <option value="6906063">United Kingdom</option>
        <option value="6906064">United States of America</option>
        <option value="6906065">Uruguay</option>
        <option value="6906066">Uzbekistan</option>
        <option value="6906067">Vanuatu</option>
        <option value="6906068">Vatican City State</option>
        <option value="6906069">Venezuela</option>
        <option value="6906070">Vietnam</option>
        <option value="6906071">Virgin Islands (Brit)</option>
        <option value="6906072">Virgin Islands (USA)</option>
        <option value="6906073">Wake Island</option>
        <option value="6906074">Wallis &amp; Futana Is</option>
        <option value="6906075">Yemen</option>
        <option value="6906076">Zambia</option>
        <option value="6906077">Zimbabwe</option>
      </select>
    </div>

    <div className="form__group">
      <label className='form__label' htmlFor="fieldciykihy">Profession <b className="required">*</b></label>
      <select id="fieldciykihy" name="cm-fo-ciykihy" required>
        <option value="">Please choose a profession...</option>
        <option value="6906079">Doctor</option>
        <option value="6906080">Dietician&#x2F;Nutritionist</option>
        <option value="6906081">Nurse</option>
        <option value="6906085">Pharmacist</option>
        <option value="6906093">Scientist</option>
        <option value="6906094">Government</option>
        <option value="6906078">Others</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldqhuihui">Specialty <b className="required">*</b></label>
      <select id="fieldqhuihui" name="cm-fo-qhuihui" required>
        <option value=""></option>
        <option value="7048837">Allergy &amp; Immunology</option>
        <option value="7048831">Cardiology</option>
        <option value="7048834">Endocrinology</option>
        <option value="7048839">Gastroenterology</option>
        <option value="7096801">General practitioner</option>
        <option value="7048835">Geriatric medicine</option>
        <option value="7048833">Neurology</option>
        <option value="7096802">Obstetrics &amp; Gynaecology</option>
        <option value="7048832">Orthopaedics</option>
        <option value="7096803">Paediatrics</option>
        <option value="7048836">Rheumatology</option>
        <option value="7048838">Respiratory medicine</option>
        <option value="7048840">Others</option>
        <option value="7048841">Not applicable</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldqhuikjd">Workplace type <b className="required">*</b></label>
      <select id="fieldqhuikjd" name="cm-fo-qhuikjd" required>
        <option value="">Please choose a workplace type...</option>
        <option value="7048846">Hospital - Community</option>
        <option value="7048847">Hospital - Government</option>
        <option value="7048848">Hospital - Private</option>
        <option value="7048849">Clinic - Government</option>
        <option value="7048850">Clinic - Private single</option>
        <option value="7048851">Clinic - Private group</option>
        <option value="7048852">Institution - Academic</option>
        <option value="7048853">Institution - Research</option>
        <option value="7048854">Other organisation - Private</option>
        <option value="7048855">Other organisation - Government</option>
        <option value="7048856">Retail pharmacy - Single</option>
        <option value="7048857">Retail pharmacy - Chain</option>
        <option value="7048858">Hospital pharmacy - Government</option>
        <option value="7048859">Hospital pharmacy - Private</option>
        <option value="7048860">Pharmacy - Trade</option>
        <option value="7048861">Pharmaceutical company</option>
        <option value="7048862">Law office</option>
        <option value="7048863">Insurance company</option>
        <option value="7048864">Voluntary welfare organisation</option>
        <option value="7048865">Laboratory</option>
        <option value="7048866">Not applicable</option>
      </select>
    </div>

    <div className="form__group">
      <div className='form__label'>
        Your personal information will be used to inform you about our latest news.
      </div>
      <label className='form__label form__label--checkbox' htmlFor="fieldazjruk">
        <input id="fieldazjruk" type="checkbox" name="cm-fo-azjruk" value="7096804" required /> Yes, I agree with the <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/" target="_blank">FrieslandCampina Privacy Policy </a> <b className="required">*</b></label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary">Subscribe</button>
    </div>
  </form>

const NewsletterAsia = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} action="//hoppinger.createsend.com/t/r/s/dhiumj/" method="post" data-newsletter>
    <input className="form__input typo--m" type="hidden" name="cm-f-ttillrdr" value="b068621c10844ae7028fc4262073923b" />

    <div className="form__group">
      <label className="form__label" htmlFor="fieldciykiik">Salutation <b className="required">*</b></label>
      <select id="fieldciykiik" name="cm-fo-ciykiik" required>
        <option value="">Choose a salutation...</option>
        <option value="7048868">Emeritus Professor</option>
        <option value="7048869">Professor</option>
        <option value="7048870">A&#x2F;Professor</option>
        <option value="7048871">Dr.</option>
        <option value="6905825">Mr.</option>
        <option value="6905826">Mrs.</option>
        <option value="7048872">Miss</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldName">First name <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldName" name="cm-name" type="text" placeholder="Your name" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldciykidl">Last name <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldciykidl" name="cm-f-ciykidl" placeholder="Your last name" required type="text" />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">Email <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-dhiumj-dhiumj" placeholder="Your email address" type="email" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldciykidk">Country <b className="required">*</b></label>
      <select id="fieldciykidk" name="cm-fo-ciykidk" required>
        <option value="">Please choose your country...</option>
        <option value="6905827">Afghanistan</option>
        <option value="6905828">Albania</option>
        <option value="6905829">Algeria</option>
        <option value="6905830">American Samoa</option>
        <option value="6905831">Andorra</option>
        <option value="6905832">Angola</option>
        <option value="6905833">Anguilla</option>
        <option value="6905834">Antigua &amp; Barbuda</option>
        <option value="6905835">Argentina</option>
        <option value="6905836">Armenia</option>
        <option value="6905837">Aruba</option>
        <option value="6905838">Australia</option>
        <option value="6905839">Austria</option>
        <option value="6905840">Azerbaijan</option>
        <option value="6905841">Azores</option>
        <option value="6905842">Bahamas</option>
        <option value="6905843">Bahrain</option>
        <option value="6905844">Bangladesh</option>
        <option value="6905845">Barbados</option>
        <option value="6905846">Belarus</option>
        <option value="6905847">Belgium</option>
        <option value="6905848">Belize</option>
        <option value="6905849">Benin</option>
        <option value="6905850">Bermuda</option>
        <option value="6905851">Bhutan</option>
        <option value="6905852">Bolivia</option>
        <option value="6905853">Bonaire</option>
        <option value="6905854">Bosnia &amp; Herzegovina</option>
        <option value="6905855">Botswana</option>
        <option value="6905856">Brazil</option>
        <option value="6905857">British Indian Ocean Ter</option>
        <option value="6905858">Brunei</option>
        <option value="6905859">Bulgaria</option>
        <option value="6905860">Burkina Faso</option>
        <option value="6905861">Burundi</option>
        <option value="6905862">Cambodia</option>
        <option value="6905863">Cameroon</option>
        <option value="6905864">Canada</option>
        <option value="6905865">Canary Islands</option>
        <option value="6905866">Cape Verde</option>
        <option value="6905867">Cayman Islands</option>
        <option value="6905868">Central African Republic</option>
        <option value="6905869">Chad</option>
        <option value="6905870">Channel Islands</option>
        <option value="6905871">Chile</option>
        <option value="6905872">China</option>
        <option value="6905873">Christmas Island</option>
        <option value="6905874">Cocos Island</option>
        <option value="6905875">Colombia</option>
        <option value="6905876">Comoros</option>
        <option value="6905877">Congo</option>
        <option value="6905878">Congo Democratic Rep</option>
        <option value="6905879">Cook Islands</option>
        <option value="6905880">Costa Rica</option>
        <option value="6905881">Cote D&#x27;Ivoire</option>
        <option value="6905882">Croatia</option>
        <option value="6905883">Cuba</option>
        <option value="6905884">Curacao</option>
        <option value="6905885">Cyprus</option>
        <option value="6905886">Czech Republic</option>
        <option value="6905887">Denmark</option>
        <option value="6905888">Djibouti</option>
        <option value="6905889">Dominica</option>
        <option value="6905890">Dominican Republic</option>
        <option value="6905891">East Timor</option>
        <option value="6905892">Ecuador</option>
        <option value="6905893">Egypt</option>
        <option value="6905894">El Salvador</option>
        <option value="6905895">Equatorial Guinea</option>
        <option value="6905896">Eritrea</option>
        <option value="6905897">Estonia</option>
        <option value="6905898">Ethiopia</option>
        <option value="6905899">Falkland Islands</option>
        <option value="6905900">Faroe Islands</option>
        <option value="6905901">Fiji</option>
        <option value="6905902">Finland</option>
        <option value="6905903">France</option>
        <option value="6905904">French Guiana</option>
        <option value="6905905">French Polynesia</option>
        <option value="6905906">French Southern Ter</option>
        <option value="6905907">Gabon</option>
        <option value="6905908">Gambia</option>
        <option value="6905909">Georgia</option>
        <option value="6905910">Germany</option>
        <option value="6905911">Ghana</option>
        <option value="6905912">Gibraltar</option>
        <option value="6905913">Great Britain</option>
        <option value="6905914">Greece</option>
        <option value="6905915">Greenland</option>
        <option value="6905916">Grenada</option>
        <option value="6905917">Guadeloupe</option>
        <option value="6905918">Guam</option>
        <option value="6905919">Guatemala</option>
        <option value="6905920">Guernsey</option>
        <option value="6905921">Guinea</option>
        <option value="6905922">Guinea-Bissau</option>
        <option value="6905923">Guyana</option>
        <option value="6905924">Haiti</option>
        <option value="6905925">Honduras</option>
        <option value="6905926">Hong Kong</option>
        <option value="6905927">Hungary</option>
        <option value="6905928">Iceland</option>
        <option value="6905929">India</option>
        <option value="6905930">Indonesia</option>
        <option value="6905931">Iran</option>
        <option value="6905932">Iraq</option>
        <option value="6905933">Ireland</option>
        <option value="6905934">Isle of Man</option>
        <option value="6905935">Israel</option>
        <option value="6905936">Italy</option>
        <option value="6905937">Jamaica</option>
        <option value="6905938">Japan</option>
        <option value="6905939">Jersey</option>
        <option value="6905940">Jordan</option>
        <option value="6905941">Kazakhstan</option>
        <option value="6905942">Kenya</option>
        <option value="6905943">Kiribati</option>
        <option value="6905944">Korea North</option>
        <option value="6905945">Korea South</option>
        <option value="6905946">Kuwait</option>
        <option value="6905947">Kyrgyzstan</option>
        <option value="6905948">Laos</option>
        <option value="6905949">Latvia</option>
        <option value="6905950">Lebanon</option>
        <option value="6905951">Lesotho</option>
        <option value="6905952">Liberia</option>
        <option value="6905953">Libya</option>
        <option value="6905954">Liechtenstein</option>
        <option value="6905955">Lithuania</option>
        <option value="6905956">Luxembourg</option>
        <option value="6905957">Macau</option>
        <option value="6905958">Macedonia</option>
        <option value="6905959">Madagascar</option>
        <option value="6905960">Malawi</option>
        <option value="6905961">Malaysia</option>
        <option value="6905962">Maldives</option>
        <option value="6905963">Mali</option>
        <option value="6905964">Malta</option>
        <option value="6905965">Marshall Islands</option>
        <option value="6905966">Martinique</option>
        <option value="6905967">Mauritania</option>
        <option value="6905968">Mauritius</option>
        <option value="6905969">Mayotte</option>
        <option value="6905970">Mexico</option>
        <option value="6905971">Midway Islands</option>
        <option value="6905972">Moldova</option>
        <option value="6905973">Monaco</option>
        <option value="6905974">Mongolia</option>
        <option value="6905975">Montenegro</option>
        <option value="6905976">Montserrat</option>
        <option value="6905977">Morocco</option>
        <option value="6905978">Mozambique</option>
        <option value="6905979">Myanmar</option>
        <option value="6905980">Namibia</option>
        <option value="6905981">Nauru</option>
        <option value="6905982">Nepal</option>
        <option value="6905983">Netherland Antilles</option>
        <option value="6905984">Netherlands</option>
        <option value="6905985">Nevis</option>
        <option value="6905986">New Caledonia</option>
        <option value="6905987">New Zealand</option>
        <option value="6905988">Nicaragua</option>
        <option value="6905989">Niger</option>
        <option value="6905990">Nigeria</option>
        <option value="6905991">Niue</option>
        <option value="6905992">Norfolk Island</option>
        <option value="6905993">Norway</option>
        <option value="6905994">Oman</option>
        <option value="6905995">Pakistan</option>
        <option value="6905996">Palau Island</option>
        <option value="6905997">Palestine</option>
        <option value="6905998">Panama</option>
        <option value="6905999">Papua New Guinea</option>
        <option value="6906000">Paraguay</option>
        <option value="6906001">Peru</option>
        <option value="6906002">Philippines</option>
        <option value="6906003">Pitcairn Island</option>
        <option value="6906004">Poland</option>
        <option value="6906005">Portugal</option>
        <option value="6906006">Puerto Rico</option>
        <option value="6906007">Qatar</option>
        <option value="6906008">Reunion</option>
        <option value="6906009">Romania</option>
        <option value="6906010">Russia</option>
        <option value="6906011">Rwanda</option>
        <option value="6906012">Saipan</option>
        <option value="6906013">Samoa</option>
        <option value="6906014">Samoa American</option>
        <option value="6906015">San Marino</option>
        <option value="6906016">Sao Tome &amp; Principe</option>
        <option value="6906017">Saudi Arabia</option>
        <option value="6906018">Senegal</option>
        <option value="6906019">Serbia</option>
        <option value="6906020">Serbia &amp; Montenegro</option>
        <option value="6906021">Seychelles</option>
        <option value="6906022">Sierra Leone</option>
        <option value="6906023">Singapore</option>
        <option value="6906024">Slovakia</option>
        <option value="6906025">Slovenia</option>
        <option value="6906026">Solomon Islands</option>
        <option value="6906027">Somalia</option>
        <option value="6906028">South Africa</option>
        <option value="6906029">South Sudan</option>
        <option value="6906030">Spain</option>
        <option value="6906031">Sri Lanka</option>
        <option value="6906032">St Barthelemy</option>
        <option value="6906033">St Eustatius</option>
        <option value="6906034">St Helena</option>
        <option value="6906035">St Kitts-Nevis</option>
        <option value="6906036">St Lucia</option>
        <option value="6906037">St Maarten</option>
        <option value="6906038">St Pierre &amp; Miquelon</option>
        <option value="6906039">St Vincent &amp; Grenadines</option>
        <option value="6906040">Sudan</option>
        <option value="6906041">Suriname</option>
        <option value="6906042">Swaziland</option>
        <option value="6906043">Sweden</option>
        <option value="6906044">Switzerland</option>
        <option value="6906045">Syria</option>
        <option value="6906046">Tahiti</option>
        <option value="6906047">Taiwan</option>
        <option value="6906048">Tajikistan</option>
        <option value="6906049">Tanzania</option>
        <option value="6906050">Thailand</option>
        <option value="6906051">Togo</option>
        <option value="6906052">Tokelau</option>
        <option value="6906053">Tonga</option>
        <option value="6906054">Trinidad &amp; Tobago</option>
        <option value="6906055">Tunisia</option>
        <option value="6906056">Turkey</option>
        <option value="6906057">Turkmenistan</option>
        <option value="6906058">Turks &amp; Caicos Is</option>
        <option value="6906059">Tuvalu</option>
        <option value="6906060">Uganda</option>
        <option value="6906061">Ukraine</option>
        <option value="6906062">United Arab Emirates</option>
        <option value="6906063">United Kingdom</option>
        <option value="6906064">United States of America</option>
        <option value="6906065">Uruguay</option>
        <option value="6906066">Uzbekistan</option>
        <option value="6906067">Vanuatu</option>
        <option value="6906068">Vatican City State</option>
        <option value="6906069">Venezuela</option>
        <option value="6906070">Vietnam</option>
        <option value="6906071">Virgin Islands (Brit)</option>
        <option value="6906072">Virgin Islands (USA)</option>
        <option value="6906073">Wake Island</option>
        <option value="6906074">Wallis &amp; Futana Is</option>
        <option value="6906075">Yemen</option>
        <option value="6906076">Zambia</option>
        <option value="6906077">Zimbabwe</option>
      </select>
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldciykihy">Profession <b className="required">*</b></label>
      <select id="fieldciykihy" name="cm-fo-ciykihy" required>
        <option value="">Please choose a profession...</option>
        <option value="6906079">Doctor</option>
        <option value="6906080">Dietician&#x2F;Nutritionist</option>
        <option value="6906081">Nurse</option>
        <option value="6906085">Pharmacist</option>
        <option value="6906093">Scientist</option>
        <option value="6906094">Government</option>
        <option value="6906078">Others</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldqhuihui">Specialty <b className="required">*</b></label>
      <select id="fieldqhuihui" name="cm-fo-qhuihui" required>
        <option value=""></option>
        <option value="7048837">Allergy &amp; Immunology</option>
        <option value="7048831">Cardiology</option>
        <option value="7048834">Endocrinology</option>
        <option value="7048839">Gastroenterology</option>
        <option value="7096801">General practitioner</option>
        <option value="7048835">Geriatric medicine</option>
        <option value="7048833">Neurology</option>
        <option value="7096802">Obstetrics &amp; Gynaecology</option>
        <option value="7048832">Orthopaedics</option>
        <option value="7096803">Paediatrics</option>
        <option value="7048836">Rheumatology</option>
        <option value="7048838">Respiratory medicine</option>
        <option value="7048840">Others</option>
        <option value="7048841">Not applicable</option>
      </select>
    </div>
    {/* <div className="form__group">
      <label className="form__label" htmlFor="fieldqhuikjd">Workplace type <b className="required">*</b></label>
      <select id="fieldqhuikjd" name="cm-fo-qhuikjd" required>
        <option value="">Please choose a workplace type...</option>
        <option value="7048846">Hospital - Community</option>
        <option value="7048847">Hospital - Government</option>
        <option value="7048848">Hospital - Private</option>
        <option value="7048849">Clinic - Government</option>
        <option value="7048850">Clinic - Private single</option>
        <option value="7048851">Clinic - Private group</option>
        <option value="7048852">Institution - Academic</option>
        <option value="7048853">Institution - Research</option>
        <option value="7048854">Other organisation - Private</option>
        <option value="7048855">Other organisation - Government</option>
        <option value="7048856">Retail pharmacy - Single</option>
        <option value="7048857">Retail pharmacy - Chain</option>
        <option value="7048858">Hospital pharmacy - Government</option>
        <option value="7048859">Hospital pharmacy - Private</option>
        <option value="7048860">Pharmacy - Trade</option>
        <option value="7048861">Pharmaceutical company</option>
        <option value="7048862">Law office</option>
        <option value="7048863">Insurance company</option>
        <option value="7048864">Voluntary welfare organisation</option>
        <option value="7048865">Laboratory</option>
        <option value="7048866">Not applicable</option>
      </select>
    </div> */}

    <div className="form__group checkbox__wrap">
      <div className='form__label'>
        Your personal information will be used to inform you about our latest news.
      </div>
      <label className='form__label form__label--checkbox' htmlFor="fieldazjruk">
        <input id="fieldazjruk" type="checkbox" name="cm-fo-azjruk" value="7096804" required /> Yes, I agree
        with the <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/"
          target="_blank">FrieslandCampina Privacy Policy </a> <b className="required">*</b></label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary">Subscribe</button>
    </div>
  </form>

const NewsletterChina = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} id="subForm" className="js-cm-form"
    action="//hoppinger.createsend.com/t/r/s/uudulyu/"
    method="post" data-newsletter
    data-id="5B5E7037DA78A748374AD499497E309E565435203D7E2D2A778DCC353839B9AE1ED6C8A5C2DE0F21ED2FD9EBA8BFDE04B4D69CE381D17ECCCF5A412D06897F5C">
    <div className="form__group">
      <label className="form__label" htmlFor="fielddjeitdj">称呼<b className="required">*</b></label>
      <ul className="form__radio-button">
        <li>
          <label><input type="radio" name="cm-fo-djeitdj" value="12643297" />先生</label>
        </li>
        <li>
          <label><input type="radio" name="cm-fo-djeitdj" value="12643298" />女士</label>
        </li>
        <li>
          <label><input type="radio" name="cm-fo-djeitdj" value="12643299" />小姐</label>
        </li>
        <li>
          <label><input type="radio" name="cm-fo-djeitdj" value="12643300" />博士</label>
        </li>
        <li>
          <label><input type="radio" name="cm-fo-djeitdj" value="12643301" />教授</label>
        </li>
      </ul>
    </div>
    <div className="form__group">
      <div className="form-cell">
        <label className="form__label" htmlFor="fieldName" >名 <b className="required">*</b></label>
        <input className="form__input typo--m" id="fieldName" name="cm-name" type="text" required />
      </div>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">电子邮件地址 <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-uudulyu-uudulyu" type="email" required />
    </div>

    <div className="form__group">
      <div className="form-cell">
        <label className="form__label" htmlFor="fielddjlldrkd">职业</label>
        <input className="form__input typo--m" id="fielddjlldrkd" name="cm-f-djlldrkd" type="text" />
      </div>
    </div>
    <div className="form__group">
      <div className='form__label'>
        您的个人信息将被用于通知您最新消息<b className="required">*</b>
      </div>

      <label className='form__label form__label--checkbox' htmlFor="fielddrukudjj">
        <input type="checkbox" id="fielddrukudjj" name="cm-f-drukudjj" value="yes" required />是，<a
          href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/"
          target="_blank">我同意皇家菲仕兰的隐私政策</a></label>
    </div>
    <div className="form__group">
      <button type="submit" className="button button--primary js-cm-submit-button">订阅</button>
    </div>
  </form>

const NewsletterIndonesia = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} id="subForm" data-newsletter className="js-cm-form"
  action="//hoppinger.createsend.com/t/r/s/ukiydti/"
  method="post" data-id="5B5E7037DA78A748374AD499497E309E2A89C53B732255B951F836B04D70604037060AF4A210158814CE242D8CFAA62CC7F23D123A90B7031CD5B7C449DFA70E">
    <div className="form__group">
      <label className="form__label" htmlFor="fielddykdljhu">Sapaan <b className="required">*</b></label>
      <ul className="form__radio-button">
        <li>
          <label><input type="radio" name="cm-fo-dykdljhu" value="11483983" />Tuan</label>
        </li>
        <li>
          <label><input type="radio" name="cm-fo-dykdljhu" value="11483984" />Nyonya</label>
        </li>
        <li>
          <label><input type="radio" name="cm-fo-dykdljhu" value="11483985" />Nona</label>
        </li>
      </ul>
    </div>
    <div className="form__group">
      <label htmlFor="fielddykdlie" className="form__label">Nama Depan <b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddykdlie" name="cm-f-dykdlie" type="text" required />
    </div>
    <div className="form__group">
      <label htmlFor="fielddykdlis" className="form__label">Awalan</label>
      <input className="form__input typo--m" id="fielddykdlis" name="cm-f-dykdlis" type="text" />
    </div>
    <div className="form__group">
      <label htmlFor="fielddykdliw" className="form__label">Nama Lengkap <b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddykdliw" name="cm-f-dykdliw" type="text" required />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">Alamat Email <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-ukiydti-ukiydti" type="email" required />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldTelephone">Nomor HP</label>
      <input className="form__input typo--m" id="fielddixukuj " name="cm-f-dixukuj" type="text" />
    </div>
    <div className="form__group">
      <label className="form__label">Kami hanya akan menggunakan informasi ini untuk mengirimkan undangan acara digital (webinar atau konferensi) via Whatsapp. </label>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddykdljku">Profesi <b className="required">*</b></label>
      <select id="fielddykdljku" name="cm-fo-dykdljku">
        <option value="">Silahkan pilih profesi anda...</option>
        <option value="11483986">Ahli gizi&#x2F; Nutrisionis</option>
        <option value="11483987">Obstetrician</option>
        <option value="11483988">Tenaga Medis</option>
        <option value="11483989">Perawat&#x2F;Asisten Praktek</option>
        <option value="11483990">Bidan</option>
        <option value="11483991">Apoteker</option>
        <option value="11483993">Ilmuwan</option>
        <option value="11483994">Instruktur Fitness&#x2F;Pelatih perorangan</option>
        <option value="11483995">Perawatan Kesehatan Anak Muda</option>
        <option value="11483996">Dokter Anak</option>
        <option value="11483997">Fisioterapis</option>
        <option value="11483998">Asisten Dokter</option>
        <option value="11483992">Lain-lain</option>
      </select>
    </div>

    <div className="form__group">
      <div className='form__label'>Informasi pribadi Anda akan digunakan untuk memberi tahu Anda tentang berita terbaru kami. <b className="required">*</b></div>
      <label className="form__label form__label--checkbox" htmlFor="fieldzdjtrty">
        <input id="fielddykdliz-0" name="cm-fo-dykdliz" value="11484510" type="checkbox" />
        Ya, saya setuju dengan kebijakan <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/" target="_blank">Privasi FrieslandCampina</a>
      </label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary js-cm-submit-button">Berlangganan</button>
    </div>
  </form>

const NewsletterBelgiumNl = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} action="//hoppinger.createsend.com/t/r/s/uyiibr/" method="post" data-newsletter>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddybllti">Aanhef <b className="required">*</b></label>
      <ul className="form__radio-button">
        <li>
          <label><input type="radio" name="cm-f-dybllti" value="Dhr" />Dhr.</label>
        </li>
        <li>
          <label><input type="radio" name="cm-f-dybllti" value="Mevr" />Mevr.</label>
        </li>
      </ul>
    </div>
    <div className="form__group">
      <label htmlFor="fielddyblltd" className="form__label">Voornaam <b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddyblltd" name="cm-f-dyblltd" type="text" placeholder="Je naam" required />
    </div>
    <div className="form__group">
      <label htmlFor="fielddybllth" className="form__label">Tussenvoegsel</label>
      <input className="form__input typo--m" id="fielddybllth" name="cm-f-dybllth" placeholder="" type="text" />
    </div>
    <div className="form__group">
      <label htmlFor="fielddyblltk" className="form__label">Achternaam <b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddyblltk" name="cm-f-dyblltk" placeholder="Je achternaam" required type="text" />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">E-mailadres <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-uyiibr-uyiibr" placeholder="Je e-mailadres" type="email" required />
    </div>


    <div className="form__group">
      <label className="form__label" htmlFor="fielddyblltu">Functie <b className="required">*</b></label>
      <select id="fielddyblltu" name="cm-f-dyblltu" required>
        <option value="">Selecteer een functie...</option>
        <option value="BC01">Arts</option>
        <option value="BC02">Diëtist / Voedingskundige</option>
        <option value="BC12">Fitnessinstructeur / Personal trainer</option>
        <option value="BC04">Jeugdgezondheidszorg</option>
        <option value="BC06">Gewichtsconsulent</option>
        <option value="BC03">Verpleegkundige / Praktijkondersteuner</option>
        <option value="BC10">Fysiotherapeut</option>
        <option value="BC09">Doktersassistent</option>
        <option value="BC05">Verloskundige</option>
        <option value="BC08">Medisch specialist</option>
        <option value="BC07">Apotheek</option>
        <option value="BC11">Overige</option>
      </select>
    </div>
    <div className="form__group">
      <div className='form__label'>
        Je gegevens worden gebruikt om je op de hoogte te houden van het laatste nieuws.<b className="required">*</b>
      </div>

      <label className='form__label form__label--checkbox' htmlFor="fieldzdjtrty">
        <input id="fieldzdjtrty" type="checkbox" name="cm-f-zdjtrty" value="yes" required /> Ik ga akkoord met het gebruik van mijn persoonlijke gegevens zoals beschreven in het <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/" target="_blank">FrieslandCampina Privacybeleid </a></label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary">Aanmelden</button>
    </div>
  </form>

const NewsletterBelgiumFr = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} action="//hoppinger.createsend.com/t/r/s/uyiizd/" method="post" data-newsletter>
    <div className="form__group">
      <label htmlFor="fielddyblltl">Introduction <b className="required">*</b></label>
      <ul className="form__radio-button">
        <li>
          <label><input type="radio" name="cm-f-dyblltl" value="M" />M.</label>
        </li>
        <li>
          <label><input type="radio" name="cm-f-dyblltl" value="Mme" />Mme.</label>
        </li>
      </ul>
    </div>
    <div className="form__group">
      <label htmlFor="fielddyblltr" className="form__label">Prénom <b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddyblltr" name="cm-f-dyblltr" type="text" placeholder="Votre nom" required />
    </div>
    <div className="form__group">
      <label htmlFor="fielddybllty" className="form__label">Second prénom</label>
      <input className="form__input typo--m" id="fielddybllty" name="cm-f-dybllty" placeholder="" type="text" />
    </div>
    <div className="form__group">
      <label htmlFor="fielddyblltj" className="form__label">Nom de famille <b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddyblltj" name="cm-f-dyblltj" placeholder="Votre nom de famille" required type="text" />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">Adresse e-mail <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-uyiizd-uyiizd" placeholder="Votre adresse e-mail" type="email" required />
    </div>

    <div className="form__group">
      <label className='form__label' htmlFor="fielddyblltt">Fonction <b className="required">*</b></label>
      <select id="fielddyblltt" name="cm-f-dyblltt" required>
        <option value="">Sélectionnez une fonction…</option>
        <option value="BC01">Médecin</option>
        <option value="BC02">Diététicien</option>
        <option value="BC12">Coach de fitness / personnel</option>
        <option value="BC04">Soins de santé pour la jeunesse</option>
        <option value="BC06">Consultant en gestion du poids</option>
        <option value="BC03">Infirmier (praticien)</option>
        <option value="BC10">Physiothérapeute</option>
        <option value="BC09">Assistant médical</option>
        <option value="BC05">Sage-femme</option>
        <option value="BC08">Médecin spécialisé</option>
        <option value="BC07">Pharmacie</option>
        <option value="BC11">Autres</option>
      </select>
    </div>
    <div className="form__group">
      <div className='form__label'>
        Vos données seront utilisées pour envoyer le matériel que vous avez commandé.<b className="required">*</b>
      </div>

      <label className="form__label form__label--checkbox" htmlFor="fieldzdjtrty">
        <input id="fieldzdjtrty" type="checkbox" name="cm-f-zdjtrty" value="yes" required /> J'accepte l'utilisation de mes données personnelles selon la politique en matière de respect de la vie <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/" target="_blank">privée du FrieslandCampina Institute</a>.</label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary">Identifiez-vous</button>
    </div>
  </form>

const NewsletterNetherlands = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} action="//hoppinger.createsend.com/t/r/s/dkhhxl/" method="post" data-newsletter>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldabhjyu">Aanhef <b className="required">*</b></label>
      <ul className="form__radio-button">
        <li>
          <label><input type="radio" name="cm-f-abhjyu" value="Dhr" />Dhr.</label>
        </li>
        <li>
          <label><input type="radio" name="cm-f-abhjyu" value="Mevr" />Mevr.</label>
        </li>
      </ul>
    </div>
    <div className="form__group">
      <label htmlFor="fieldabhjjl" className="form__label">Voornaam <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldabhjjl" name="cm-f-abhjjl" type="text" placeholder="Je naam" required />
    </div>
    <div className="form__group">
      <label htmlFor="fieldabhjjj" className="form__label">Tussenvoegsel</label>
      <input className="form__input typo--m" id="fieldabhjjj" name="cm-f-abhjjj" placeholder="" type="text" />
    </div>
    <div className="form__group">
      <label htmlFor="fieldabhjjt" className="form__label">Achternaam <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldabhjjt" name="cm-f-abhjjt" placeholder="Je achternaam" required type="text" />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">E-mailadres <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-dkhhxl-dkhhxl" placeholder="Je e-mailadres" type="email" required />
    </div>


    <div className="form__group">
      <label className="form__label" htmlFor="fieldabhjtj">Functie <b className="required">*</b></label>
      <select id="fieldabhjtj" name="cm-f-abhjtj" required>
        <option value="">Selecteer een functie...</option>
        <option value="BC01">Arts</option>
        <option value="BC02">Diëtist / Voedingskundige</option>
        <option value="BC12">Fitnessinstructeur / Personal trainer</option>
        <option value="BC04">Jeugdgezondheidszorg</option>
        <option value="BC06">Gewichtsconsulent</option>
        <option value="BC13">Leefstijlcoach</option>
        <option value="BC03">Verpleegkundige / Praktijkondersteuner</option>
        <option value="BC10">Fysiotherapeut</option>
        <option value="BC09">Doktersassistent</option>
        <option value="BC05">Verloskundige</option>
        <option value="BC08">Medisch specialist</option>
        <option value="BC07">Apotheek</option>
        <option value="BC11">Overige</option>
      </select>
    </div>
    <div className="form__group">
      <div className='form__label'>
        Je gegevens worden gebruikt om je op de hoogte te houden van het laatste nieuws.<b className="required">*</b>
      </div>

      <label className="form__label form__label--checkbox" htmlFor="fieldzdjtrty">
        <input id="fieldzdjtrty" type="checkbox" name="cm-f-zdjtrty" value="yes" required /> Ik ga akkoord met het gebruik van mijn persoonlijke gegevens zoals beschreven in het <a href="https://privacy.frieslandcampina.com/nl/frieslandcampina-privacybeleid/" target="_blank">FrieslandCampina Privacybeleid </a></label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary">Aanmelden</button>
    </div>
  </form>

const NewsletterNigeria = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} id="subForm" className="js-cm-form"
    action="//hoppinger.createsend.com/t/r/s/oityukh/"
   method="post" data-id="5B5E7037DA78A748374AD499497E309E4E87D41E9C281A059B64FF2071FD5A64D961A1C59FCD886422A6A6D0AA12C35F598F71B891E264B723004138AEF27AC4">
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhqkytj">Salutation <b className="required">*</b></label>
      <select id="fielddhqkytj" name="cm-fo-dhqkytj" required>
        <option value="">Choose a salutation...</option>
        <option value="28979614">Emeritus Professor</option>
        <option value="28979615">Professor</option>
        <option value="28979616">A/Professor</option>
        <option value="28979617">Dr.</option>
        <option value="28979618">Mr.</option>
        <option value="28979619">Mrs.</option>
        <option value="28979620">Miss</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldName">Name<b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldName" name="cm-name" type="text" placeholder="Your name" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">Email <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-oityukh-oityukh" placeholder="Your email address" type="email" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fielddhqkytt">Profession <b className="required">*</b></label>
      <select id="fielddhqkytt" name="cm-fo-dhqkytt" required>
        <option value="">Please choose a profession...</option>
        <option value="28979621">Doctor</option>
        <option value="28979622">Dietician / Nutritionist</option>
        <option value="28979623">Nurse</option>
        <option value="28979624">Pharmacist</option>
        <option value="28979625">Scientist</option>
        <option value="28979626">Government</option>
        <option value="28979627">Others</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhqkyti">Specialty <b className="required">*</b></label>
      <select id="fielddhqkyti" name="cm-fo-dhqkyti" required>
        <option value=""></option>
        <option value="28979628">Allergy &amp; Immunology</option>
        <option value="28979629">Cardiology</option>
        <option value="28979630">Endocrinology</option>
        <option value="28979631">Gastroenterology</option>
        <option value="28979632">General practitioner</option>
        <option value="28979633">Geriatric medicine</option>
        <option value="28979636">Neurology</option>
        <option value="28979637">Obstetrics &amp; Gynaecology</option>
        <option value="28979638">Orthopaedics</option>
        <option value="28979639">Paediatrics</option>
        <option value="28979640">Rheumatology</option>
        <option value="28979641">Respiratory medicine</option>
        <option value="28979634">Others</option>
        <option value="28979635">Not applicable</option>
      </select>
    </div>


    <div className="form__group">
      <div className='form__label'>
        Your personal information will be used to inform you about our latest news.
      </div>
      <label className="form__label form__label--checkbox" htmlFor="fielddjhjolt">
        <input id="fielddjhjolt" type="checkbox" name="cm-f-djhjolt" value="7096804" required /> Yes, I agree with the <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/" target="_blank">FrieslandCampina Privacy Policy </a> <b className="required">*</b></label>
    </div>

    <div className="form__group">
      <button className="button button--primary js-cm-submit-button" type="submit">Subscribe</button>
    </div>
  </form>  


const NewsletterPakistan = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} 
   action="//hoppinger.createsend.com/t/r/s/nlrjllr/" method="post" data-id="5B5E7037DA78A748374AD499497E309E6DE9BDA49F9A44DF408718924668061B359CFEBC49742508DDB3142351F4DBCE9A65A449A1804AECC1485012494123CE">
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhqkyw">Salutation <b className="required">*</b></label>
      <select id="fielddhqkyw" name="cm-fo-dhqkyw" required>
        <option value="">Choose a salutation...</option>
        <option value="28979571">Emeritus Professor</option>
        <option value="28979570">Professor</option>
        <option value="28979569">A&#x2F;Professor</option>
        <option value="28979568">Dr.</option>
        <option value="28979567">Mr.</option>
        <option value="28979566">Mrs.</option>
        <option value="28979565">Miss</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldName">First name <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldName" name="cm-name" type="text" placeholder="Your name" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fielddhxujlh">Last name <b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddhxujlh" name="cm-f-dhxujlh" placeholder="Your last name" required type="text" />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">Email <b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-nlrjllr-nlrjllr" placeholder="Your email address" type="email" required />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhxujly">Phone number</label>
      <input className="form__input typo--m" id="fielddhxujly " name="cm-f-dhxujly" placeholder="Your phone number" type="text" />
    </div>

    <div className="form__group">
      <label className='form__label' htmlFor="fielddhqkyyd">Profession <b className="required">*</b></label>
      <select id="fielddhqkyyd" name="cm-fo-dhqkyyd" required>
        <option value="">Please choose a profession...</option>
        <option value="28979578">Doctor</option>
        <option value="28979577">Dietician&#x2F;Nutritionist</option>
        <option value="28979576">Nurse</option>
        <option value="28979575">Pharmacist</option>
        <option value="28979574">Scientist</option>
        <option value="28979573">Government</option>
        <option value="28979572">Others</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhqkyyk">Specialty <b className="required">*</b></label>
      <select id="fielddhqkyyk" name="cm-fo-dhqkyyk" required>
        <option value=""></option>
        <option value="28979586">Allergy &amp; Immunology</option>
        <option value="28979585">Cardiology</option>
        <option value="28979592">Endocrinology</option>
        <option value="28979591">Gastroenterology</option>
        <option value="28979590">General practitioner</option>
        <option value="28979589">Geriatric medicine</option>
        <option value="28979588">Neurology</option>
        <option value="28979587">Obstetrics &amp; Gynaecology</option>
        <option value="28979584">Orthopaedics</option>
        <option value="28979583">Paediatrics</option>
        <option value="28979582">Rheumatology</option>
        <option value="28979581">Respiratory medicine</option>
        <option value="28979580">Others</option>
        <option value="28979579">Not applicable</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhqkyjr">Workplace type <b className="required">*</b></label>
      <select id="fielddhqkyjr" name="cm-fo-dhqkyjr" required>
        <option value="">Please choose a workplace type...</option>
        <option value="28979601">Hospital - Community</option>
        <option value="28979600">Hospital - Government</option>
        <option value="28979599">Hospital - Private</option>
        <option value="28979607">Clinic - Government</option>
        <option value="28979606">Clinic - Private single</option>
        <option value="28979605">Clinic - Private group</option>
        <option value="28979604">Institution - Academic</option>
        <option value="28979603">Institution - Research</option>
        <option value="28979602">Other organisation - Private</option>
        <option value="28979613">Other organisation - Government</option>
        <option value="28979612">Retail pharmacy - Single</option>
        <option value="28979611">Retail pharmacy - Chain</option>
        <option value="28979610">Hospital pharmacy - Government</option>
        <option value="28979609">Hospital pharmacy - Private</option>
        <option value="28979608">Pharmacy - Trade</option>
        <option value="28979598">Pharmaceutical company</option>
        <option value="28979597">Law office</option>
        <option value="28979596">Insurance company</option>
        <option value="28979595">Voluntary welfare organisation</option>
        <option value="28979594">Laboratory</option>
        <option value="28979593">Not applicable</option>
      </select>
    </div>

    <div className="form__group">
      <div className='form__label'>
        Your personal information will be used to inform you about our latest news.
      </div>
      <label className='form__label form__label--checkbox' htmlFor="fieldazjruk">
        <input id="fieldazjruk" type="checkbox" name="cm-fo-azjruk" value="7096804" required /> Yes, I agree with the <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/" target="_blank">FrieslandCampina Privacy Policy </a> <b className="required">*</b></label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary">Subscribe</button>
    </div>
  </form>


const NewsletterMexico = () =>
  <form onSubmit={() => {
    gtmPush({
      event: "form_submit", 
      action: "form_start"
    })
  }} 
   action="//hoppinger.createsend.com/t/r/s/nlyoud/" method="post" data-id="5B5E7037DA78A748374AD499497E309E86CAB566D3C41641B0C2129F8C5FA7B7980768855A150974B2EB69E78311958D2891DE878F4F25D16D0A7D7084F9F41B">
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhjiujki">Saludo <b className="required">*</b></label>
      <select id="fielddhjiujki" name="cm-fo-dhjiujki" required>
        <option value="">Elija un saludo...</option>
        <option value="29792976">Profesor Emérito</option>
        <option value="29792977">Profesor</option>
        <option value="29792978">A/Profesor</option>
        <option value="29792979">Dr.</option>
        <option value="29792980">Sr.</option>
        <option value="29792981">Sra.</option>
        <option value="29792982">Srta.</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhjiujkd">Nombre de pila<b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddhjiujkd" name="cm-f-dhjiujkd" type="text" placeholder="Su nombre" required />
    </div>

    <div className="form__group">
      <label className="form__label" htmlFor="fielddhjiujkh">Su apellido<b className="required">*</b></label>
      <input className="form__input typo--m" id="fielddhjiujkh" name="cm-f-dhjiujkh" placeholder="Su apellido" required type="text" />
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fieldEmail">Correo electrónico<b className="required">*</b></label>
      <input className="form__input typo--m" id="fieldEmail" name="cm-nlyoud-nlyoud" placeholder="Su dirección de correo electrónico" type="email" required />
    </div>

    <div className="form__group">
      <label className='form__label' htmlFor="fielddhjiujkk">Profesión <b className="required">*</b></label>
      <select id="fielddhjiujkk" name="cm-fo-dhjiujkk" required>
        <option value="">Elija una profesión...</option>
        <option value="29792983">Médico</option>
        <option value="29792984">Dietista/Nutricionista</option>
        <option value="29792985">Enfermera</option>
        <option value="29792986">Farmacéutico</option>
        <option value="29792987">Científico</option>
        <option value="29792988">Gobierno</option>
        <option value="29792989">Otros</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhjiujku">Especialidad <b className="required">*</b></label>
      <select id="fielddhjiujku" name="cm-fo-dhjiujku" required>
        <option value="">Por favor, elija una especialidad...</option>
        <option value="29792990">Alergia e Inmunología</option>
        <option value="29792991">Cardiología</option>
        <option value="29792992">Endocrinología</option>
        <option value="29792993">Gastroenterología</option>
        <option value="29792994">Medicina general</option>
        <option value="29792995">Geriatría</option>
        <option value="29792999">Neurología</option>
        <option value="29793000">Obstetricia y ginecología</option>
        <option value="29793001">Ortopedia</option>
        <option value="29793002">Pediatría</option>
        <option value="29793003">Residentes en medicina</option>
        <option value="29793004">Medicina respiratoria</option>
        <option value="29792996">Reumatología</option>
        <option value="29792997">Otros</option>
        <option value="29792998">No aplicable</option>
      </select>
    </div>
    <div className="form__group">
      <label className="form__label" htmlFor="fielddhjiujul">Tipo de lugar de trabaj <b className="required">*</b></label>
      <select id="fielddhjiujul" name="cm-fo-dhjiujul" required>
        <option value="">Por favor, elija un tipo de lugar de trabajo...</option>
        <option value="29793005">Hospital - Gobierno</option>
        <option value="29793006">Hospital privado</option>
        <option value="29793007">Clínica - Privada</option>
        <option value="29793008">Otro</option>
      </select>
    </div>

    <div className="form__group">
      <div className='form__label'>
        Su información personal será utilizada para informarle sobre nuestras últimas noticias..
      </div>
      <label className='form__label form__label--checkbox' htmlFor="fieldazjruk">
        <input id="fieldazjruk" type="checkbox" name="cm-fo-azjruk" value="7096804" required /> Sí, estoy de acuerdo con la <a href="https://privacy.frieslandcampina.com/english/frieslandcampina-privacy-policy/" target="_blank">política de privacidad de FrieslandCampina </a> <b className="required">*</b></label>
    </div>

    <div className="form__group">
      <button type="submit" className="button button--primary">Suscribirse</button>
    </div>
  </form>

